import { ENDPOINT } from "apiRoutes";

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const rawData = window.atob(base64);

    return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

function getBaseUrl(baseUrl) {
    return (baseUrl || ENDPOINT || "").replace(/\/$/, "");
}

export async function enableOrderPush({
    baseUrl,
    companyId,
    orderId,
    vapidPublicKey,
}) {
    if (!window.isSecureContext) {
        throw new Error("Push notifications require HTTPS");
    }

    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
        throw new Error("Push notifications are not supported in this browser");
    }

    if (!companyId || !orderId) {
        throw new Error("Missing companyId or orderId");
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
        throw new Error("Notification permission denied");
    }

    const registration = await navigator.serviceWorker.register("/sw.js");

    const existingSubscription = await registration.pushManager.getSubscription();
    let subscription = existingSubscription;

    if (!subscription) {
        if (!vapidPublicKey) {
            throw new Error("Notifications are not configured yet. Missing VAPID key.");
        }

        subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
        });
    }

    const endpointBase = getBaseUrl(baseUrl);
    const response = await fetch(
        `${endpointBase}/api/restaurant/orders/${orderId}/push-subscribe`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ companyId, subscription }),
        },
    );

    if (!response.ok) {
        throw new Error(`Failed to register push subscription (${response.status})`);
    }

    return true;
}
